import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, finalize, map } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';
import { helper } from 'src/environments/helper';
import { IProiect } from '../../proiecte.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { CommonService } from 'src/app/services/common.service';
import { ProiecteService } from '../../proiecte.service';
import { ICompartimentForm, ICompartimentUpdatePayload } from './update-compartiment-proiect.interface';

@Component({
    selector: 'app-update-compartiment-proiect',
    templateUrl: './update-compartiment-proiect.component.html',
    styleUrls: ['./update-compartiment-proiect.component.scss']
})
export class UpdateCompartimentProiectComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    passedProiectId!: number;
    directiiActive: Generic[] = [];
    compartimenteActive$: Observable<Generic[]> = new Observable();


    defaultParameter: { name: string; id: number } = {
        name: '-- Alegeți --',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        id_directie: new FormControl(this.data.proiect.id_directie || -1, [Validators.required, Validators.min(0)]),
        id_compartiment: new FormControl(this.data.proiect.id_compartiment || -1, []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            proiect: IProiect,
            directiiActive: Generic[],
        },
        private dialogRef: MatDialogRef<UpdateCompartimentProiectComponent>,
        private notificationService: NotificationService,
        private commonService: CommonService,
        private proiecteService: ProiecteService,
    ) { }

    ngOnInit(): void {
        this.passedProiectId = this.data.proiect.id_proiect;
        this.directiiActive = this.data.directiiActive;

        this.loadCompartimenteActive(this.data.proiect.id_directie);
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { id_directie, id_compartiment } = this.form.value as ICompartimentForm;
        const payload: ICompartimentUpdatePayload = {
            id_directie,
            id_compartiment
        };

        this.proiecteService
            .updateCompartiment(this.passedProiectId, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onDirectieChange(directieId: number): void {
        if (directieId > 0) {
            this.loadCompartimenteActive(directieId);
        } else {
            this.compartimenteActive$ = new Observable<Generic[]>((observer) => {
                observer.next([{ name: '--Alegeți--', id: -1 }]);
                observer.complete();
            });
        }
    }

    loadCompartimenteActive(directieId?: number) {
        this.isLoading = true;
        let compartimenteObservable$ = directieId
            ? this.commonService.getCompartimenteByDirectie(directieId)
            : this.commonService.getCompartimenteActive();

        this.compartimenteActive$ = compartimenteObservable$.pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => {
                this.isLoading = false;
            })
        );
    }
}
